import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // obtener el token del localStorage
    const token = localStorage.getItem('token');

    // si tenemos token agregamos token y secret
    if (token) {
      const headers = req.headers
        .set('Authentication', `Bearer ${token}`);

      // clonamos la solicitud para incluir los headers
      const authReq = req.clone({ headers });

      // pasar la solicitud clonada con los headers al siguiente interceptor o servicio
      return next.handle(authReq);
    }

    // si por alguna razon no entra a los if se va sin headers
    return next.handle(req);
  }
}
